import type { FC } from "react";

import styled from "styled-components";

import { setFontVariant, colorsPalettes } from "@similarweb/styles";
import { Button, DotsLoader, Modal, Textfield } from "@similarweb/ui-components";

import { useOnEnter } from "app/custom-hooks/useOnKeyUp";
import type { SegmentsModalProps } from "app/components/React/TableSelectionComponents/segment-selection/segments-modal/types";
import { translate } from "app/filters/i18nFilter";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon } = colorsPalettes;

const TextCaption = styled.span`
    ${setFontVariant("caption", carbon[300])};
    display: flex;
    align-items: center;
`;

export const Wizard: FC<SegmentsModalProps> = (props) => {
    const { footerProps, bodyProps } = props;
    const { onCancel, saveProps } = footerProps;
    const { onSegmentNameChange, segmentName, isLoading: isLoadingBody } = bodyProps;
    const { assetName, isValidName, errorMessage } = segmentName;
    const { onSave, isDisabled, isLoading: isLoadingSave } = saveProps;

    const handleNameChange = (name: string) => {
        onSegmentNameChange(name);
    };

    useOnEnter(onSave);

    return (
        <>
            <Modal.Header>
                <Modal.Title>{translate("segments.popup.wizard.title")}</Modal.Title>
            </Modal.Header>
            <Modal.Content gap="4px">
                <TextCaption>{translate("segments.popup.wizard.body.segment.name")}</TextCaption>
                <Textfield
                    error={!isValidName}
                    errorMessage={errorMessage}
                    onChange={handleNameChange}
                    placeholder={translate("segments.popup.wizard.body.enter.name.placeholder")}
                    defaultValue={assetName}
                    loadingComponent={<DotsLoader />}
                    isLoading={isLoadingBody}
                    disabled={isLoadingBody}
                />
                <FlexColumn>
                    <TextCaption>{`• ${translate("segments.popup.wizard.body.segment.disclaimer1")}`}</TextCaption>
                    <TextCaption>{`• ${translate("segments.popup.wizard.body.segment.disclaimer2")}`}</TextCaption>
                    <TextCaption style={{ paddingLeft: "7px" }}>
                        {translate("segments.popup.wizard.body.segment.disclaimer3")}
                    </TextCaption>
                </FlexColumn>
            </Modal.Content>
            <Modal.Footer>
                <Button
                    type="flat"
                    onClick={onCancel}
                >
                    {translate("segments.popup.wizard.footer.cancel")}
                </Button>
                <Button
                    type="primary"
                    isDisabled={isDisabled}
                    onClick={onSave}
                    isLoading={isLoadingSave}
                >
                    {translate("segments.popup.wizard.footer.save")}
                </Button>
            </Modal.Footer>
        </>
    );
};
